import ValidationStrategy from './ValidationStrategy';

class StrictValidationStrategy extends ValidationStrategy {
  static ALLOWED_TYPES = ['image/jpeg', 'image/png'];
  static MAX_FILE_SIZE_MB = 5;
  static MAX_DIMENSION = 7680;
  static MIN_WIDTH = 250;
  static MIN_HEIGHT = 250;

  validate(file) {
    const isValidType = StrictValidationStrategy.ALLOWED_TYPES.includes(file.type);
    if (!isValidType) {
      return { 
        isValid: false, 
        errorMessage: "Seuls les fichiers PNG/JPEG sont acceptés pour LinkedIn" 
      };
    }

    const isValidSize = file.size / 1024 / 1024 <= StrictValidationStrategy.MAX_FILE_SIZE_MB;
    if (!isValidSize) {
      return { 
        isValid: false, 
        errorMessage: `Le fichier doit faire moins de ${StrictValidationStrategy.MAX_FILE_SIZE_MB} Mo pour LinkedIn` 
      };
    }

    // Vérifications spécifiques LinkedIn
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      const cleanupAndResolve = (result) => {
        URL.revokeObjectURL(objectUrl);
        resolve(result);
      };

      img.onload = () => {
        if (img.width > StrictValidationStrategy.MAX_DIMENSION || img.height > StrictValidationStrategy.MAX_DIMENSION) {
          cleanupAndResolve({ 
            isValid: false, 
            errorMessage: `Les dimensions ne doivent pas dépasser ${StrictValidationStrategy.MAX_DIMENSION}px pour LinkedIn` 
          });
        } else if (img.width < StrictValidationStrategy.MIN_WIDTH || img.height < StrictValidationStrategy.MIN_HEIGHT) {
          cleanupAndResolve({ 
            isValid: false, 
            errorMessage: `L'image doit faire au moins ${StrictValidationStrategy.MIN_WIDTH}x${StrictValidationStrategy.MIN_HEIGHT}px pour LinkedIn` 
          });
        } else {
          cleanupAndResolve({ isValid: true });
        }
      };
      img.onerror = () => {
        cleanupAndResolve({ 
          isValid: false, 
          errorMessage: "Impossible de lire l'image" 
        });
      };
      img.src = objectUrl;
    });

  }



  getHelpMessage() {
    return `Seuls les fichiers PNG/JPEG de moins de ${StrictValidationStrategy.MAX_FILE_SIZE_MB} Mo, min ${StrictValidationStrategy.MIN_WIDTH}x${StrictValidationStrategy.MIN_HEIGHT}px et max ${StrictValidationStrategy.MAX_DIMENSION}px sont acceptés (Google My Business)`;
  }
}

export default StrictValidationStrategy;